// import Axios from "axios";
// import { basicCatch } from "./api-helpers";

import Axios from "axios";
import { basicCatch } from "./api-helpers";

const state = {};

export const getters = {};

export const actions = {
  // ROUTES
  // POST
  createAnnouncement(context, announcementData) {
    return new Promise((res, rej) => {
      Axios.post("/admin/notification", announcementData)
        .then(() => {
          res();
        })
        .catch((err) => {
          basicCatch(
            err,
            "Something went wrong while trying to create announcement."
          );
          rej();
        });
    });
  },

  sendAdminEmail(context, emailData) {
    return new Promise((res, rej) => {
      Axios.post("/admin/email", emailData)
        .then((response) => {
          res(response.data.data);
        })
        .catch((err) => {
          basicCatch(err, "Something went wrong while trying to send email.");
          rej();
        });
    });
  },

  getAdminDashboard() {
    return new Promise((res, rej) => {
      Axios.get("/admin/dashboard")
        .then((response) => {
          res(response.data.data);
        })
        .catch((err) => {
          basicCatch(err, "Something went wrong while loading dashboard data.");
          rej();
        });
    });
  },

  getAdminEmailLogs(context, page = 1) {
    return new Promise((res, rej) => {
      Axios.get(`/admin/email-logs?page=${page}`)
        .then((response) => {
          res(response.data.data);
        })
        .catch((err) => {
          basicCatch(err, "Something went wrong while loading email logs.");
          rej();
        });
    });
  },
};

export const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
